import React from "react";
import { StepOptionItem } from "./StepOptionItem";

interface StepOptionsGroupProps {
  fields: {
    items: any[];
  };
}

export const StepOptionsGroup: React.FC<StepOptionsGroupProps> = ({ fields }) => {
  const items = fields.items || [];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 w-full gap-24 my-24">
      {items?.map((item, i) => (
        <StepOptionItem key={i} index={i+1} {...item} />
      ))}
    </div>
  );
};
